/* eslint-disable sort-keys */
import { IS_GE_CHECKOUT, jewlr_t } from "helpers/application"

const contactData = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  return {
    production: {
      title: "My order is being processed",
      articles: [
        {
          link: "/order/change",
          text:
            "Yes, you can make a change to the stone(s) you selected as long as your order is still in production, and has not yet been packaged or shipped. We recommend that you let us know about any changes you would like to make as soon as possible, as orders could be completed earlier than indicated on our website. To select a different gemstone/birthstone for your " +
            jewlr_t("terms.jewelry") +
            " item, please ",
          title: "Can I Select A Different Gemstone?",
        },
        {
          link: "/order/change",
          text:
            "Yes, you can make a change to the metal you selected as long as your order is still in production, and has not yet been packaged or shipped. We recommend that you let us know about any changes you would like to make as soon as possible, as orders could be completed earlier than indicated on our website. To select a different precious metal (sterling silver, 10K or 14K white, yellow, or rose gold) for your " +
            jewlr_t("terms.jewelry") +
            "  item, please ",
          title: "Can I Select A Different Metal?",
        },
        {
          link: "/order/change",
          text: "Yes, you can make a change to the ring size you selected as long as your order is still in production, and has not yet been packaged or shipped. We recommend that you let us know about any changes you would like to make as soon as possible, as orders could be completed earlier than indicated on our website. To select a different ring size, please ",
          title: "Can I Change My Ring Size?",
        },
        {
          link: "/order/change",
          text: "Yes, you can make a change to the length of chain you have selected as long as your order is still in production, and has not yet been packaged or shipped. We recommend that you let us know about any changes you would like to make as soon as possible, as orders could be completed earlier than indicated on our website. To select a different chain length for your necklace, please ",
          title: "Can I Select A Different Chain Length?",
        },
        {
          link: "/contact_form",
          text:
            "Yes, you can change the delivery address of your order as long as your order has not yet shipped. If your order has already been processed and shipped, we will not able to change the delivery address or reroute your order to another address for you. To change the " +
            jewlr_t("terms.Shipping") +
            " address for your order, please ",
          title: "Can I Change My " + jewlr_t("terms.Shipping") + " Address?",
        },
        {
          link: "/order/upgrade-shipping",
          text:
            "Yes, you can upgrade to express " +
            jewlr_t("terms.Shipping") +
            ", if that option is available in your area, and as long as your order has not yet shipped. Express " +
            jewlr_t("terms.Shipping") +
            " options are available for an additional charge. To upgrade to express " +
            jewlr_t("terms.Shipping") +
            ", please ",
          title: "Can I Upgrade To Express " + jewlr_t("terms.Shipping") + " ?",
        },
      ],
    },
    received: {
      title: "I have received my order",
      articles: [
        {
          link: "/order/resizing",

          secondText:
            "Due to the nature of tungsten, cobalt, and ceramic, we are unable to resize these rings.",
          text: "You can request a resizing of up to two full sizes on most rings, including engraved items, within 30 days of the original shipment date. There will be an additional charge for a re-engraving a ring base, and you will be responsible for related delivery costs. To have a ring resized, please ",
          title: "How Do I Get My Ring Resized?",
        },
        {
          link: "/info/warranty-information",
          secondText:
            "To have your " +
            jewlr_t("terms.jewelry") +
            " item repaired, please ",
          secondTextLink: "/order/repair",
          text:
            "Yes, you can have an item repaired. Your purchase is covered by a one-year warranty against manufacturing defects and workmanship. If your " +
            jewlr_t("terms.jewelry") +
            ` piece has been modified by an unauthorized ${sl.config.site_title} representative, the warranty becomes void. For more information about ${sl.config.site_title}'s one-year warranty, please `,
          title: "Can I Get An Item Repaired?",
        },
        {
          link: "/info/returns",
          secondText:
            "To return your " + jewlr_t("terms.jewelry") + " item, please ",
          secondTextLink: "/order/return",
          text:
            `You can return any item purchased at ${sl.config.site_title}, including engraved items for a full refund with our hassle-free, ${is_ge_checkout ? "30" : "99"}-day return policy. Returned items must be in a new and unworn condition, with the ` +
            jewlr_t("terms.jewelry") +
            " tag still attached. For more information about our return policy, please ",
          title: "How Do I Return An Item?",
        },
        {
          link: "/order/repair",
          text:
            "Yes, you can select a different gemstone/birthstone on most pieces. Please note that there may be additional charges, and you will be responsible for related delivery costs. To select a different gemstone for your " +
            jewlr_t("terms.jewelry") +
            " item, please ",
          title: "Can I Select A Different Gemstone?",
        },
        {
          link: "/order/repair",
          text:
            "Yes, you can select a different metal on most pieces. Please note that there may be additional charges, and you will be responsible for related delivery costs. To select a different precious metal (sterling silver, 10K or 14K white, yellow, or rose gold) for your " +
            jewlr_t("terms.jewelry") +
            " item, please ",
          title: "Can I Select A Different Metal?",
        },
        {
          link: "/order/repair",
          text: "Yes, you can make a change to an engraving. Please note that there may be additional charges, and you will be responsible for related delivery costs. To make a change to your engraving, please ",
          title: "Can I Change An Engraving?",
        },
      ],
    },
    assistance: {
      title: "I still need assistance",
      articles: [
        {
          text: `If you need further assistance, please send us an <a href="https://${sl.config.site_url}/contact_form">email</a> , including your order number and a summary of your concern. Our customer support agents will be happy to assist you. If you would like to speak to one of our live agents, we are available Monday to Sunday, 9:00 am–5:30 pm EST, via LiveChat. `,
          title: `How Do I Contact ${sl.config.site_title}?`,
        },
      ],
    },
  }
}

export default contactData
